import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteConfig } from '@/mocks/siteConfig';
import NewsletterForm from './NewsletterForm';

const footerLinks = [
  {
    title: 'Navigate',
    links: [
      { label: 'Home', to: '/' },
      { label: 'Ultimate Guide', to: '/article/superbuy-spreadsheet-guide' },
      { label: 'Safety Guide', to: '/article/superbuy-spreadsheet-safety' },
      { label: 'Shopping Tips', to: '/article/superbuy-spreadsheet-tips' },
      { label: 'Comparison', to: '/article/superbuy-spreadsheet-comparison' },
    ],
  },
  {
    title: 'Top Categories',
    links: categories.slice(0, 5).map((cat) => ({
      label: cat.name,
      href: cat.url,
      isExternal: true,
    })),
  },
  {
    title: 'More Categories',
    links: categories.slice(5, 10).map((cat) => ({
      label: cat.name,
      href: cat.url,
      isExternal: true,
    })),
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 pt-16 md:pt-20 pb-8 mx-3 md:mx-5 mb-3 md:mb-5 rounded-2xl md:rounded-3xl">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row items-start justify-between mb-14 gap-6">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-file-list-3-line text-background-50 text-base"></i>
            </div>
            <span className="font-heading text-lg font-semibold text-background-50">
              Superbuy Spread
            </span>
          </div>
          <p className="text-background-50/40 text-sm max-w-[400px] leading-relaxed">
            {siteConfig.tagline} — helping international shoppers discover products smarter through organized resources and expert guides.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-14">
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-xs font-semibold text-background-50/70 uppercase tracking-wider mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {'isExternal' in link && link.isExternal ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-background-50/40 text-sm hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : 'to' in link ? (
                      <Link
                        to={link.to}
                        className="text-background-50/40 text-sm hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : null}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <NewsletterForm />
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/25 text-xs">
            &copy; {currentYear} {siteConfig.siteName}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-background-50/25 text-xs underline cursor-pointer">Twitter</span>
            <span className="text-background-50/25 text-xs underline cursor-pointer">Pinterest</span>
            <span className="text-background-50/25 text-xs underline cursor-pointer">Reddit</span>
            <span className="text-background-50/25 text-xs underline cursor-pointer">YouTube</span>
          </div>
        </div>
      </div>
    </footer>
  );
}